export const GET_TV_CHANNELS = "GET_TV_CHANNELS";

export const GET_CHANNELS_FOR_SELECT = "GET_CHANNELS_FOR_SELECT";

export const CREATE_TV_CHANNEL = "CREATE_TV_CHANNEL";

export const UPDATING_TV_CHANNEL = "UPDATING_TV_CHANNEL";

export const DELETE_TV_CHANNEL = "DELETE_TV_CHANNEL";

export const GET_LIVE_TV_CREATE_BY_ADMIN = "GET_LIVE_TV_CREATE_BY_ADMIN"
